<div class="gung-barcode position-relative">
  <img [src]="barcodeImageUrl" alt="barcode code128 {{code}}">
  @if (showCode) {
    <span class="d-block text-center w-100 small">{{code}}</span>
  }
</div>
